import React from "react";
import Input from "../Input";
import Select from "../Select";
import RadioGroup from "../RadioGroup";
import { YES_NO_OPTIONS, TSHIRT_OPTIONS } from "components/userForms/constants";

const TranslationVolunteering = ({
  formData,
  setFormData,
  handleChange,
  formErrors,
}) => {
  return (
    <div>
      <div>
        <RadioGroup
          label="Would you be willing to lead a small group?"
          name="willingToLeadGroup"
          options={YES_NO_OPTIONS}
          selectedValue={formData.willingToLeadGroup}
          onChange={(e) => {
            handleChange(e);

            if (e.target.value === "no") {
              setFormData((prev) => ({
                ...prev,
                languagesSpoken: "",
              }));
            }
          }}
          error={formErrors.willingToLeadGroup}
          required
        />

        {/* Conditional render */}
        {formData.willingToLeadGroup === "yes" && (
          <div className="grid md:grid-cols-2">
            <Input
              label="If Yes, language(s) spoken"
              name="languagesSpoken"
              value={formData.languagesSpoken}
              onChange={handleChange}
              error={formErrors.languagesSpoken}
              required
            />
          </div>
        )}
      </div>

      <div className="grid md:grid-cols-2">
        <Select
          label="T-Shirt Size"
          name="tshirtSize"
          value={formData.tshirtSize}
          onChange={handleChange}
          options={TSHIRT_OPTIONS}
          error={formErrors.tshirtSize}
          required
          fontWeight={"font-semibold"}
          textColor={"text-secondary"}
        />
      </div>
    </div>
  );
};

export default TranslationVolunteering;
